import { useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api'

export interface ReservationsAddonStatus {
  active: boolean
  billingCycle: string | null
  activatedAt: string | null
  expiresAt: string | null
  cancelAtPeriodEnd: boolean
  superadminBypass: boolean
}

// Reservations add-on status for the current tenant. Authenticated but not
// gated by the add-on itself, so the sidebar can decide whether to show the
// section. Pre-release: only superadmins see it (superadminBypass), since no
// tenant has the add-on flag active yet.
export function useReservationsAddon() {
  const { data, isLoading } = useQuery({
    queryKey: ['reservations-addon-status'],
    queryFn: async () => {
      const response = await api.get('/reservations/status')
      return response.data.data as ReservationsAddonStatus
    },
    staleTime: 5 * 60 * 1000,
  })

  const visible = (data?.active ?? false) || (data?.superadminBypass ?? false)

  return { status: data, active: data?.active ?? false, superadminBypass: data?.superadminBypass ?? false, visible, isLoading }
}
